import { useEffect, useMemo, useState } from "react";
import api from "../services/api";
import { createLesson } from "../services/courses";

import common from "../styles/commonStyles";
import layout from "../styles/layoutStyles";

export default function UploadVideo() {
  const [courses, setCourses] = useState([]);
  const [modules, setModules] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [videoTitle, setVideoTitle] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  const canUpload = useMemo(() => Boolean(selectedModule), [selectedModule]);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/courses");
        setCourses(res.data || []);
      } catch (e) {
        setError(e?.message || "Failed to load courses");
      }
    })();
  }, []);

  const loadModules = async (courseId) => {
    setModules([]);
    setSelectedModule("");
    if (!courseId) return;

    try {
      const res = await api.get(`/courses/${courseId}/modules`);
      setModules(res.data || []);
    } catch (e) {
      setError(e?.message || "Failed to load modules");
    }
  };

  const handleUpload = async (file) => {
    setError("");
    setStatus("");

    if (!file) return;
    if (!videoTitle.trim()) {
      setError("Enter a video title first.");
      return;
    }
    if (!selectedModule) {
      setError("Select a module first.");
      return;
    }

    try {
      setStatus("Requesting upload URL...");
      const contentType = file.type || "application/octet-stream";

      const formData = new FormData();
      formData.append("file", file);
      const res = await api.post("/upload/file", formData);
      const file_url = res.data.url;

      setStatus("Saving lesson...");
      await createLesson({
        module_id: selectedModule,
        title: videoTitle.trim() || file.name,
        type: "video",
        content_url: file_url,
      });

      setStatus("✅ Upload successful!");
    } catch (e) {
      setStatus("");
      setError(e?.message || "Upload failed");
    }
  };

  return (
    <div style={layout.container}>
      <h1>🎥 Upload Video</h1>

      <div style={{ ...common.card, maxWidth: "500px" }}>
        {/* COURSE */}
        <label>
          Course
          <select
            style={common.input}
            value={selectedCourse}
            onChange={(e) => {
              const next = e.target.value;
              setSelectedCourse(next);
              loadModules(next);
            }}
          >
            <option value="">Select course</option>
            {courses.map((c) => (
              <option key={c.id} value={c.id}>
                {c.title}
              </option>
            ))}
          </select>
        </label>

        {/* TITLE */}
        <label>
          Video Title
          <input
            type="text"
            style={common.input}
            placeholder="Enter video title..."
            value={videoTitle}
            onChange={(e) => setVideoTitle(e.target.value)}
          />
        </label>

        {/* MODULE */}
        <label>
          Module
          <select
            style={common.input}
            value={selectedModule}
            onChange={(e) => setSelectedModule(e.target.value)}
            disabled={!selectedCourse}
          >
            <option value="">Select module</option>
            {modules.map((m) => (
              <option key={m.id} value={m.id}>
                {m.title}
              </option>
            ))}
          </select>
        </label>

        {/* FILE */}
        <input
          style={common.input}
          type="file"
          accept="video/*"
          disabled={!canUpload}
          onChange={(e) => { handleUpload(e.target.files?.[0]); e.target.value = null; }}
        />

        {/* STATUS */}
        {status && <p>{status}</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
    </div>
  );
}